import { CircleArrowUpIcon } from '@docnboard/icons/rc';

export const UpdatePlan = () => {
  return (
    <div className="flex flex-row ml-2 items-center gap-1 text-primary">
      <CircleArrowUpIcon className="w-4 h-4" />
      <span>Plus</span>
    </div>
  );
};
